"use client";

import { Search } from "lucide-react";

import { KeyCombo } from "@/components/ui/kbd";
import { SimpleTooltip } from "@/components/ui/tooltip";
import {
  NAV_ARRIVE,
  NAV_CORAL_MARK,
  NAV_FIELD,
  NAV_INK_FOCUS_RING,
  arriveStep,
} from "@/components/nav/nav-styles";
import { useNavTypeToSearch } from "@/components/nav/useNavTypeToSearch";
import { useApplePlatform } from "@/hooks/useApplePlatform";
import { searchKeys } from "@/lib/keyboard";
import { cn } from "@/lib/utils";

const FIELD_TRIGGER = cn(NAV_FIELD, NAV_INK_FOCUS_RING, NAV_ARRIVE);

/**
 * The white field in the top bar that opens search: the icon, what search
 * covers and the keys that open it. The tooltip names the keys in words.
 * Typing while the pointer is over it, or while it has focus, opens search
 * with that keystroke already in the input.
 */
export default function NavSearchTrigger({ buttonRef, onClick }) {
  const apple = useApplePlatform();
  const typeToSearchProps = useNavTypeToSearch({ ref: buttonRef });

  return (
    <SimpleTooltip
      side="bottom"
      content={
        apple
          ? "Hold Command and press K to open search."
          : "Hold Ctrl and press K to open search."
      }
    >
      <button
        {...typeToSearchProps}
        type="button"
        onClick={onClick}
        aria-label="Search"
        className={FIELD_TRIGGER}
        style={arriveStep(0)}
      >
        <Search className={cn("h-4 w-4 shrink-0", NAV_CORAL_MARK)} />
        <span className="truncate">Search pages, people, content…</span>
        <KeyCombo keys={searchKeys(apple)} className="ml-auto" />
      </button>
    </SimpleTooltip>
  );
}
